import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import SiteLayout from "../components/feature/SiteLayout";
import Home from "../pages/home/page";
import Characters from "../pages/characters/page";
import Settings from "../pages/settings/page";
import Story from "../pages/story/page";
import Faq from "../pages/faq/page";
import About from "../pages/about/page";

const routes: RouteObject[] = [
  {
    element: <SiteLayout />,
    children: [
      { path: "/", element: <Home /> },
      { path: "/characters", element: <Characters /> },
      { path: "/settings", element: <Settings /> },
      { path: "/story", element: <Story /> },
      { path: "/faq", element: <Faq /> },
      { path: "/about", element: <About /> },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;